export const getOptionsPrivacyDictionary = {
    "1": 'Apenas eu',
    "2": 'Meus Contatos',
    "3": 'Todos',
}
